<template>
  <InfuseDescriptionList :rows="rows" :item="item" :loading="loading">
    <template #ocppVersion="{ data }">OCPP-{{ data }} </template>

    <template #readOnly="{ data }">
      <font-awesome-icon
        :icon="['fas', data ? 'circle-check' : 'circle-xmark']"
        :class="data ? 'text-primary-500' : 'text-neutral-500'"
      ></font-awesome-icon>
    </template>
  </InfuseDescriptionList>
</template>

<script lang="ts" setup>
import { InfuseDescriptionList } from '@infuse/ui/components';
import { UiDescriptionListRow } from '@infuse/ui/domain';
import { computed, ComputedRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { CentralSystem, ConnectionType } from '@infuse/e-connector/central-system/domain';

interface Props {
  item: CentralSystem;
  loading?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  loading: false
});

const { t } = useI18n();

const rows: ComputedRef<UiDescriptionListRow[]> = computed(() => [
  {
    name: 'name',
    term: t('e_connector.common.centralSystem.name'),
    detailField: 'name'
  },
  {
    name: 'type',
    term: t('e_connector.common.centralSystem.type'),
    detailField: 'type'
  },
  {
    name: 'ocppVersion',
    term: t('e_connector.common.centralSystem.ocppVersion'),
    detailField: 'ocppVersion'
  },
  {
    name: 'uri',
    term: t('e_connector.common.centralSystem.url_manual'),
    detailField: 'uri',
    hidden: !props.item.uri || props.item.type !== ConnectionType.SOAP,
    copyable: true
  },
  {
    name: 'readOnly',
    term: t('e_connector.common.centralSystem.readOnly'),
    detailField: 'readOnly',
    hidden: !props.item.readonly
  }
]);
</script>
